export default function Logo({ className = "", size = "base" }) {
  const sizes = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
  };

  return (
    <span className={`font-black uppercase tracking-tight ${sizes[size] || sizes.base} ${className}`} data-testid="app-logo">
      <span className="text-zinc-900">Locazione </span>
      <span className="text-teal-700">Turistica</span>
    </span>
  );
}
